const UNLISTED_BANK = 'UNLISTED_BANK';

export class DropBoxService {
    static getUnlistedBankItem = (items) => {
        return items.find((i) => i?.value === UNLISTED_BANK);
    };

    static isUnlistedBank = (item) => item?.value === UNLISTED_BANK;
}
